import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import BrandMark from "./BrandMark";
import "./LegalPage.css";

export default function LegalLayout({ type, title, intro, children }) {
  return (
    <div className="legal-shell">
      <header className="legal-nav" data-testid="legal-navigation">
        <div className="page-width legal-nav-inner">
          <Link data-testid="legal-nav-home-link" to="/"><BrandMark compact /></Link>
          <div className="legal-nav-meta"><span>LEGAL / {type}</span><Link data-testid="legal-nav-contact-link" to="/#contact">CONTACT <ArrowUpRight size={14} /></Link></div>
        </div>
      </header>
      <main className="legal-main page-width">
        <Link data-testid="legal-back-home-link" className="legal-back-link" to="/"><ArrowLeft size={16} /> BACK TO TFUN SITES</Link>
        <div className="legal-heading"><span className="eyebrow">TFUN SITES / {type}</span><h1 data-testid={`${type.toLowerCase()}-title`}>{title}</h1><p>{intro}</p><small>Last updated: March 2026</small></div>
        <article className="legal-copy">{children}</article>
      </main>
      <footer className="legal-footer"><div className="page-width legal-footer-inner"><BrandMark /><p>TFUN Sites — A Division of The Follow Up Ninja</p><div><Link data-testid="legal-footer-home-link" to="/">Home</Link><Link data-testid="legal-footer-privacy-link" to="/privacy-policy">Privacy Policy</Link><Link data-testid="legal-footer-terms-link" to="/terms">Terms</Link></div></div></footer>
    </div>
  );
}
